export const getApiUrl = (): string => {
  if (process.env.NODE_ENV === 'development') {
    return process.env.REACT_APP_API_URL_DEV || 'http://plano:3001/api';
  }
  
  return process.env.REACT_APP_API_URL_PROD || process.env.REACT_APP_API_URL || 'https://tu-api-produccion.com/api';
};

export const API_URL = getApiUrl();

export const isDevelopment = (): boolean => {
  return process.env.NODE_ENV === 'development';
};

export const isDebugMode = (): boolean => {
  return process.env.REACT_APP_DEBUG_MODE === 'true';
};